module.exports = __webpack_public_path__ + "static/media/wave (4).cae3433c.svg";